import { render } from "./statisticsDetailed.vue?vue&type=template&id=f2023bb2"
import script from "./statisticsDetailed.vue?vue&type=script&lang=js"
export * from "./statisticsDetailed.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__